import { ReactNode } from 'react';
import { Sidebar } from '../Sidebar';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen bg-[#edf5ef]">
      <Sidebar />
      <main className="flex-1 ml-80 px-6 py-8">
        {children}
      </main>
    </div>
  );
} 